import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation(); // Get the current path

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when path changes
  }, [pathname]); // Runs when pathname changes

  return null; // No UI needed
};

export default ScrollToTop;
